import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useCitiesData }  from '../../domain/city/city.domain';
import ContentLoader from 'react-content-loader';
import Router from 'next/router';

const CityCarouselMobile = (props) => {

  const { title, type, paragraph } = props;    

  const [isClient, setIsClient] = useState(false);
  const { data: cities, isLoading: citiesLoading, error: citiesError } = useCitiesData(); 

  const dataLength = _.size(cities);

  const getScreenWidth = (referenceWidth) => {
      return window.innerWidth <= referenceWidth ? referenceWidth : 1920;
  };    

  const containerRef = useRef(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [transformValue, setTransformValue] = useState(0);
  const [cardWidth, setCardWidth] = useState(getScreenWidth(412));

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);
  const [diffX, setDiffX] = useState(0);    

  useEffect(() => {
      const handleResize = () => {
          setCardWidth(getScreenWidth(1366));
      };

      window.addEventListener('resize', handleResize);

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  useEffect(() => {        
    if (!containerRef.current) return;

    const container = containerRef.current;
    const activeCard = container.querySelectorAll('.mobile-city-carousel-slide')[currentCardIndex];
    if (!activeCard) return;

    const containerWidth = container.parentElement.offsetWidth;
    const cardRect = activeCard.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    
    
    const cardCenter = cardRect.left + cardRect.width / 2;
    const containerCenter = containerRect.left + containerWidth / 2;

    setTransformValue(containerCenter - cardCenter);       
      
  }, [currentCardIndex, cardWidth]);  


  useEffect(() => {
    setIsClient(true);
  }, []);

  let containerWidth = 1500;
  let containerHeight = 400;
  let boxWidth = 400;
  let offset = 0;  

  const handleStart = (e) => {
      setIsDragging(true);
      // Use e.clientX for mouse events and e.touches[0].clientX for touch events
      setStartX(e.clientX || e.touches[0].clientX);
  };

  const handleMove = (e) => {
      if (!isDragging) return;
      const newCurrentX = e.clientX || e.touches[0].clientX;
      const newDiffX = newCurrentX - startX;
      setCurrentX(newCurrentX);
      setDiffX(newDiffX);
  };

  const handleEnd = () => {
      setIsDragging(false);
      if (diffX > 50) {
          // Dragged right, go to previous card
          goToPreviousCard();
      } else if (diffX < -50) {
          // Dragged left, go to next card
          goToNextCard();
      }
      setDiffX(0); // Reset the difference
  };   

  const goToNextCard = () => {
      if (currentCardIndex < dataLength - 1) {
        const newIndex = currentCardIndex + 1;
        setCurrentCardIndex(newIndex);
      }else {
        setCurrentCardIndex(0); 
      }
  };

  const goToPreviousCard = () => {
      if (currentCardIndex > 0) {
        const newIndex = currentCardIndex - 1;
        setCurrentCardIndex(newIndex);
      }
  };
  
  const trackWidth = `${dataLength * 100}%`;
  const wrapperWidth = `${(100 / dataLength).toFixed(5)}%`;     

  const onCitySelect = (cityName) => { 
    Router.push(`/bookings?city=${cityName}`).then(() => window.scrollTo(0, 0));    
  }; 

  const renderLandingCarousel = () => {
      if(!isClient) return null;
      return (
          <div className='main-grid-container'>
              <div className='main-grid-item'>
                  <div className='mobile-city-carousel-landing-header-container'>
                      <h4 className='mobile-city-carousel-landing-h4'>
                          Where is HOMii
                      </h4>
                      <p className='mobile-city-carousel-landing-p'>
                          You can find one in every buzzing city centre from Jozi to Cape Town!
                      </p>
                  </div>
              </div>
              <div className='main-grid-item main-grid-xs-12'>
                  <div className='mobile-city-carousel-landing-container'>
                    {renderCarousel()}
                  </div>
              </div>
          </div>
      );
  };  

  const renderFindaSpaceCarousel = () => {
    if(!isClient) return null;
    return (
      <div id="mobile-city-carousel-find-a-space-page">
        <div className='mobile-city-carousel-wrapper'>
            <div>
              <h4 className='mobile-city-carousel-find-a-space-header'>
                  {title}
              </h4>
              <p  style={{ marginTop: 24, marginBottom: 24, color: '#A2A2A2' }}>
                  {paragraph}
              </p>
            </div>            
            {renderCarousel()}
        </div>          
      </div>
    );
  };

  const renderCarousel = () => {
    return (
      <>
          <div className='mobile-city-carousel'>
            <div className='mobile-city-carousel-slider'>
              <div className='mobile-city-carousel-slider-tray-wrap'>
                <ul ref={containerRef}
                  style={{ width: trackWidth, transform: `translate3d(${transformValue}px, 0px, 0px)` }}
                  onMouseDown={handleStart}
                  onMouseMove={handleMove}
                  onMouseUp={handleEnd}
                  onMouseLeave={handleEnd} 
                  onTouchStart={handleStart}
                  onTouchMove={handleMove}
                  onTouchEnd={handleEnd}                   
                  className='mobile-city-carousel-slider-tray'>
                   {_.map(cities, (city, index) => {
                      const bookableSpace = Math.floor(_.get(city, 'bookableSpaces') / 10) * 10;
                      const cityName = _.get(city, 'name');
                      const hasNewBuildings = _.get(city, 'hasNewBuildings');
                      return (
                        <div className="mobile-city-carousel-slider-wrapper" key={index}>
                          <li style={{ width: wrapperWidth, paddingBottom: '20%' }} className='mobile-city-carousel-slide'>
                            <div className="mobile-city-carousel-inner-slide">                            
                                <div className='mobile-city-carousel-inner-slide-image-container'>
                                    <img
                                      src={_.get(city, 'images[0]')}
                                      alt={`City of ${cityName}`}
                                      width="100%"
                                      height="100%"               
                                      id={`${cityName}-carousel-button`}
                                      onClick={() => onCitySelect(cityName)}
                                      className='mobile-city-carousel-image'
                                    />
                                </div>
                                <p className="mobile-city-carousel-city-name" style={{ fontWeight: 'bold', marginBottom: 5 }}>
                                  {cityName}
                                </p>
                                <p style={{ fontSize: 16, marginTop: 0 }}>  
                                  Over {bookableSpace}+ spaces
                                </p>
                                {hasNewBuildings && (
                                  <p style={{ fontSize: 16, marginTop: 0 }}>
                                    New buildings available
                                  </p>
                                )}
                            </div>
                          </li>
                        </div>                        
                      );
                   })}
                </ul>
              </div>
            </div>
            <div className="mobile-city-carousel-button-container">
                <button type="button" aria-label="Back"
                    className="mobile-city-carousel-button mobile-city-carousel-button-back"
                    onClick={goToPreviousCard}
                    role="button" aria-disabled="false" id="mobile-city-carousel-button-back" right="14">
                      <span
                        className="mobile-city-carousel-label">
                          <svg
                            className="mobile-city-carousel-icon-root"
                            focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z">
                            </path>
                        </svg>
                      </span>
                    <span className="mobile-city-carousel-ripple-root"></span>
                </button>
                <button type="button" aria-label="Next"
                    className="mobile-city-carousel-button mobile-city-carousel-button-next"
                    onClick={goToNextCard}
                    role="button" aria-disabled="false" id="mobile-city-carousel-button-next" right="11">
                      <span
                        className="mobile-city-carousel-label">
                          <svg
                            className="mobile-city-carousel-icon-root"
                            focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z">
                            </path>
                        </svg>
                      </span>
                    <span className="mobile-city-carousel-ripple-root"></span>
                </button>
            </div>            
          </div>
      </>
    )
  };

  const renderCarouselLoading = () => {
      if(!isClient) return null;
      return (
        <>
          <div style={{ marginTop: 10 }}>
            <ContentLoader
                  width={containerWidth}
                  height={containerHeight}
                  viewBox={`0 0 ${containerWidth} ${containerHeight}`}
                  backgroundColor="#1E252C"
                  foregroundColor="#181D1F"
                  animate
            >
                  <rect x="12" y="58" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x="12" y="340" rx="2" ry="2" width="150" height="10" />

                  <rect x={462 - offset} y="57" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x={462 - offset} y="340" rx="2" ry="2" width="150" height="10" />

                  <rect x={912 - 2 * offset} y="56" rx="2" ry="2" width={boxWidth} height="260" />
                  <rect x={912 - 2 * offset} y="340" rx="2" ry="2" width="150" height="10" />

              </ContentLoader>
          </div>

        </>
      );
  };

  const renderContent =() => {    
    return (
      <>
        {type === 'Landing' ? renderLandingCarousel() : null}
        {type === 'FindaSpace' ? renderFindaSpaceCarousel() : null}
      </>
    );    

  };

  return (
    <>      
      {citiesLoading ? renderCarouselLoading() : renderContent()}
    </>
  );  

};

export default CityCarouselMobile;

CityCarouselMobile.propTypes = {
    cities: PropTypes.array,
    title: PropTypes.string,
    type: PropTypes.string,
    paragraph: PropTypes.string,
};